export default __webpack_public_path__ + "static/media/Skirt of the Hell Walker (nm).2f01fb5e.jpg";